import { render } from "./BasePage.vue?vue&type=template&id=074dff1b&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"

import "./BasePage.vue?vue&type=style&index=0&id=074dff1b&scoped=true&lang=css"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074dff1b"]])

export default __exports__